import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=1897a014"
import script from "./AddNewUser.vue?vue&type=script&lang=ts"
export * from "./AddNewUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports